import React from 'react';
import MUIAlertTitle, {
  AlertTitleProps as MUIAlertTitleProps,
} from '@material-ui/lab/AlertTitle';

interface AlertTitleProps extends MUIAlertTitleProps {}

const AlertTitle = (props: AlertTitleProps) => {
  return <MUIAlertTitle {...props}>{props.children}</MUIAlertTitle>;
};

AlertTitle.displayName = 'AlertTitle';

export default AlertTitle;
